module.exports = __webpack_public_path__ + "static/media/slider-2-min.0358a9dc.jpg";